import { AdapterSharedProperties } from 'owa-addins-core';
import { getFolderTable } from 'owa-folders';
import { getUserPermissionForFolderId } from 'owa-mail-filterable-menu-behavior';
import Item from 'owa-service/lib/contract/Item';
import { getUserEmailAddress } from 'owa-session-store';

export const getSharedProperties = (item: Item) => (): AdapterSharedProperties => {
    const folderId = item.ParentFolderId.Id;
    const userEmail = getUserEmailAddress();
    const folderPermission = getUserPermissionForFolderId(folderId, userEmail);
    const { principalSMTPAddress } = getFolderTable().get(folderId);

    return {
        owner: principalSMTPAddress,
        delegatePermissions: {
            Read: folderPermission.ReadItems == 'FullDetails',
            Create: folderPermission.CanCreateItems,
            EditOwn: folderPermission.EditItems == 'All' || folderPermission.EditItems == 'Owned',
            EditAll: folderPermission.EditItems == 'All',
            DeleteOwn:
                folderPermission.DeleteItems == 'All' || folderPermission.DeleteItems == 'Owned',
            DeleteAll: folderPermission.DeleteItems == 'All',
        },
    };
};
